import GdsClient, { EventBody } from '../../gds-api-client';
import { MemberWeddingClient } from '../../wws-api-client';
import WeddingApiClient from '@xo-union/sdk-weddings';
import Cookies from 'js-cookie';
import React, { createContext, useState } from 'react';

import { AddressComponents } from '../helpers/addressComponentHelper';
import { LegacyEvent } from '../LegacyModal/EventForm';

export type GdsEvent = EventBody | LegacyEvent | LegacyEvent[] | null;

export type EventType = 'Ceremony' | 'Reception' | 'WeddingEvent' | 'WeddingDay';

type CategoryCode = { category_code: string };

interface UpsertWeddingParams {
  wedding: {
    member_id: string;
    wedding_date: string;
  };
}

export interface BookingParam {
  id?: string;
  member_id: string;
  category_code: string;
  source: string;
  vendor_name: string | null;
  vendor_profile_id?: string | null;
  address_components: AddressComponents;
}

interface UpsertBookingParams {
  booking: BookingParam;
}

interface UnionWeddingApi {
  // @ts-ignore
  getBookings: (memberId: string, CategoryCode?) => Promise<any>;
  deleteBooking: (bookingId: string) => Promise<any>;
  upsertWedding: (params: UpsertWeddingParams) => Promise<any>;
  upsertBooking: (params: UpsertBookingParams) => Promise<any>;
}

interface Default {
  weddingApi: UnionWeddingApi;
  gdsApi: GdsClient;
  gdsEvent: GdsEvent;
  memberWeddingApi: MemberWeddingClient;
  setGdsEvent: (gdsEvent: GdsEvent) => void;
  eventType?: EventType;
  setEventType: (type: EventType) => void;
  bookingsSource?: string;
}

interface Props {
  children: any;
}

export const ApiClientsContext = createContext<Default>({} as Default);

const bookingsSource = process.env.BOOKINGS_API_SOURCE || process.env.REACT_APP_BOOKINGS_API_SOURCE;

if (!bookingsSource) {
  throw new Error('BOOKINGS_API_SOURCE is required');
}

const getWeddingApiHost = (): string =>
  process.env.GDS_ENV === 'production' || process.env.REACT_APP_GDS_ENV === 'production'
    ? 'https://api.weddings.xogrp.com'
    : 'https://qa-api.weddings.xogrp.com';

const getSessionToken = (): string => Cookies.get('xo-session-token') || '';

export const ApiProvider: React.FC<Props> = ({ children }) => {
  const [weddingApi] = useState(
    () =>
      new WeddingApiClient({
        host: getWeddingApiHost(),
        apiKey: process.env.WEDDING_API_KEY || process.env.REACT_APP_WEDDING_API_KEY,
        membershipSessionToken: getSessionToken(),
      })
  );
  const [gdsApi] = useState(() => new GdsClient());
  const [memberWeddingApi] = useState(() => new MemberWeddingClient());
  const [event, setEvent] = useState<GdsEvent>(null);
  const [eventType, setEventType] = useState<EventType | undefined>(undefined);

  const setGdsEvent = (gdsEvent: GdsEvent): void => {
    setEvent(gdsEvent);
  };

  const setType = (type: EventType): void => {
    setEventType(type);
  };

  return (
    <ApiClientsContext.Provider
      value={{
        weddingApi,
        gdsApi,
        memberWeddingApi,
        gdsEvent: event,
        setGdsEvent,
        eventType,
        setEventType: setType,
        bookingsSource,
      }}
    >
      {children}
    </ApiClientsContext.Provider>
  );
};
